import { render } from "./GalerieImages.vue?vue&type=template&id=78fadff0&scoped=true"
import script from "./GalerieImages.vue?vue&type=script&lang=js"
export * from "./GalerieImages.vue?vue&type=script&lang=js"

import "./GalerieImages.vue?vue&type=style&index=0&id=78fadff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fadff0"]])

export default __exports__